import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import _, { chain, partial, split, isEmpty, toPlainObject } from 'lodash';

import { routes } from '../../routes';
import { PATH } from '../../constants/path';
import { STATIC_RESOURCES_ROOT } from '../../constants';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { getPostLoginRedirectPath } from '../../services/authentication/utils';
import { SSO_ERROR_LOGIN_FAILED } from '../../services/authentication/constants';

import { flushPersistedState } from '../../store';
import { mapRoutes } from '../../utils/routeUtils';
import { toSameOriginUrl } from '../../utils/ssoUtil';
import { getLocaleFromRoutes } from '../../services/i18n/utils';

import {
    registerAdBlockerDetection,
    registerCookieDetection
} from '../../services/adblocker/actions';
import { fetchEbonPartners } from '../../services/ebon/actions';
import { fetchBilletteriePartnersIfNeeded } from '../../services/billetterie/actions';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { logoutUser } from '../../services/authentication/logout/actions';
import { loginUserWithToken } from '../../services/authentication/login/actions';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const {
            location: { search, pathname },
            loginUserWithToken,
            logoutUser,
            isAuthed,
            history
        } = this.props;

        const values =
            search &&
            chain(search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();

        const token = values && values.tk;
        const provider = values && values.provider; // Authentification origin

        if (token) {
            if (isAuthed) {
                const callback = new RegExp(PATH.ACCOUNT_PATH).test(pathname)
                    ? () => history.push(PATH.HOME_PATH)
                    : null;
                logoutUser(callback);
            }

            loginUserWithToken(
                { token, provider },
                response => {
                    history.push(pathname);
                    // membre limité : vue d'information dédiée, sinon chemin mémorisé avant connexion
                    const redirectPath = getPostLoginRedirectPath(response, null);
                    const externalUrl = toSameOriginUrl(redirectPath);
                    if (externalUrl) {
                        flushPersistedState().then(() => window.location.assign(externalUrl));
                    } else if (redirectPath) {
                        history.push(redirectPath);
                    }
                },
                // échange refusé (token invalide ou expiré) : le middleware a déjà déconnecté
                // l'utilisateur, on l'emmène sur la page de connexion avec la modale d'erreur
                // plutôt que de le laisser sur /?tk=xxx sans aucun retour
                () => history.push(`${PATH.LOGIN_PATH}?error=${SSO_ERROR_LOGIN_FAILED}`)
            );
        }

        this.detectAdBlocker();
        this.checkCookies();
    }

    componentDidMount() {
        const {
            fetchPartnersIfNeeded,
            fetchCategoriesIfNeeded,
            fetchEbonPartners,
            fetchBilletteriePartnersIfNeeded
        } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();
        fetchBilletteriePartnersIfNeeded();
    }

    componentWillReceiveProps(nextProps) {
        const { location } = this.props;

        if (nextProps.location !== location) {
            this.changeCurrentLocaleIfNeeded(nextProps);
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, currentLocale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== currentLocale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    detectAdBlocker() {
        const { registerAdBlockerDetection } = this.props;

        const head = document.getElementsByTagName('head')[0];

        const noAdBlockDetected = () => {
            registerAdBlockerDetection(false);
        };
        const adBlockDetected = () => {
            registerAdBlockerDetection(true);
        };

        // we will dynamically generate some 'bait'.
        const script = document.createElement('script');
        script.id = 'adblock-detection';
        script.type = 'text/javascript';
        script.src = `${STATIC_RESOURCES_ROOT}/scripts/adframe.js`;
        script.onload = noAdBlockDetected;
        script.onerror = adBlockDetected;

        head.appendChild(script);

        // clean up stale bait
        const oldScript = document.getElementById('adblock-detection');
        if (oldScript) {
            head.removeChild(oldScript);
        }
    }

    checkCookies() {
        const { registerCookieDetection } = this.props;

        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        registerCookieDetection(cookieEnabled);
    }

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token),
        user: toPlainObject(state.account.user)
    };
};

const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchEbonPartners,
    fetchBilletteriePartnersIfNeeded,
    fetchCategoriesIfNeeded,
    changeCurrentLocale,
    loginUserWithToken,
    logoutUser,
    registerAdBlockerDetection,
    registerCookieDetection
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js